import { RouteTravelMode } from "./@google/types";

/**
 * Converts legacy Google maps Directions API travel mode to new Routes API travel mode.
 */
const convertLegacyTravelMode = (
  travelMode: RouteTravelMode | "DRIVING" | "WALKING",
): RouteTravelMode => {
  if (travelMode === "DRIVING") {
    return RouteTravelMode.DRIVE;
  }
  if (travelMode === "WALKING") {
    return RouteTravelMode.WALK;
  }
  return travelMode;
};

export { convertLegacyTravelMode };
